export default __webpack_public_path__ + "static/media/48.c5a38490.jpg";